import axios from "axios";
import axiosInstance from "./axiosInstance";
export const verifyAccountIFSC = async (p) => {
  const ifsc = p.ifsc || "SBIN0000001"
  try {
   const response = await axios.get(`https://ifsc.razorpay.com/${ifsc}`);
    return {
      success:response.data.success || true,
      data: response?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const addSettlementAccount = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/add_sattel_account`, p, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};



export const deleteSettlementAccountAPI = async (id) => {
  try {
    const response = await axiosInstance.delete(`/api/settle/delete/${id}`);
    return {
      success:response.data.success || true,
      data: response?.data,
      message: response?.data?.message || "Deleted successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to delete. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const fraddSettlementAccountForPayout = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/add_sattel_account/payout`, p, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data || response?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const fruploadDocSettlementAccountForPayout = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/uploaddoc_sattel_account/payout`, p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};






export const withdrawSettlementBalance = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/wallet-to-bank`, p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const fetchSettlementCharge = async () => {
  try {
    const response = await axiosInstance.get("/api/settle/charge");
    return {
      success: true,
      data: response?.data?.data,
      message: response?.data?.message || "Settlement charge fetched",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to fetch settlement charge",
    };
  }
};

export const withdrawDMTBalance = async (p) => {
  try {
    const response = await axiosInstance.post(`/api/settle/dmt-to-bank`, p);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSettalmentsLists= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/list`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchDMTLists= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/dmt-list`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSettalmentAccounts= async (params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/me`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSettalmentAccountsByNumber= async (mobile,params={}) => {
  try {
    const response = await axiosInstance.get(`/api/settle/banks_by_user/${mobile}`,{
        params:params
    });
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
export const fetchSingleSettalmentAccount= async (bankId) => {
  try {
    const response = await axiosInstance.get(`/api/settle/single-bank/${bankId}`);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const checkSettlementStatusAPI = async (beneId) => {
  
  const res = await axiosInstance.get(`/api/settle/check-status/${beneId}`);
  return res.data;
};

// 2️⃣ Upload Documents
export const uploadSettlementDocsAPI = async (formData) => {
  const res = await axiosInstance.post("/api/settle/upload-docs", formData);
  return res.data;
};

export const settlementBankStatus= async (id) => {
  try {
    const response = await axiosInstance.post(`/api/admin/settle/bank/status/checking/${id}`);
    return response.data
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        " failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};
